<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Q8TwZw/tc-custom/9781442416963.jpg?1730532875948" alt="This image is the cover for the book Moonglass"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Moonglass
      </h1>
      <p class="bookDescription body article font2">
        <b><b>Sarah Dessen says this “incredible first novel” is “fresh and wise, all at once.”</b></b><br/><br/><i>I read once that water is a symbol for emotions. And for a while now, I’ve thought maybe my mother drowned in both.<br/>     </i>Anna’s life is upended when her father accepts a job transfer the summer before her junior year. It’s bad enough that she has to leave her friends behind, but her dad is moving them to the beach where her parents first met and fell in love—a place awash in memories that Anna would just as soon leave under the surface.<br/>     While life on the beach is pretty great, with ocean views and one adorable lifeguard in particular, there are also family secrets that were buried years ago. And the ebb and flow of the ocean’s tide means that nothing—not the sea glass that collects along the shore, and not the truths behind Anna’s mother’s death—stays buried forever.<i></i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jessi Kirby
      </h2>
      
      <p class="authorDescription body article">Jessi Kirby is the author of <I>Moonglass</I>, which was an ABA New Voices selection in 2011; <I>In Honor</I>; and <I>Golden</I>. When she&#8217;s not writing, she works as a middle school librarian. She lives with her husband and two children in Crystal Cove, California. Visit her at <a href="http://www.jessikirby.com/">JessiKirby.com</a>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      S&S Books for Young Readers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?46a6f296